<template>
  <div class="dock-control-panel">
    <!-- title -->
    <div
      class="dock-control-panel-header fz16 pl5 pr5 flex-align-center flex-row flex-justify-between"
    >
      <span>设备操作 {{ dockName }}</span>
      <span @click="closeControlPanel" style="cursor: pointer">
        <CloseOutlined />
      </span>
    </div>
    <!-- setting -->
    <DeviceSettingBox :sn="sn" :deviceInfo="deviceInfo"></DeviceSettingBox>
    <!-- 设备属性新增设置 -->
    <div class="device-set-add" v-if="dock3Show">
      <div class="set-add-item">
        <div class="set-add-item-left">
          <div class="item-label">
            部署
            <a-tooltip placement="top">
              <template #title>
                <div>您可以在大疆行业 APP上切换部署模式</div>
              </template>
              <InfoCircleOutlined />
            </a-tooltip>
          </div>
        </div>
        <div class="set-add-item-right">
          <DeviceSettingPopover
            :visible="setcarInfo.visible"
            :loading="setcarInfo.loading"
            @confirm="onCarConfirm()"
            @cancel="onCarCancel()"
            :okText="'一键标定'"
          >
            <template #formContent>
              <div class="car-content">
                <div>场地评估</div>
                <div>
                  <div style="margin: 4px 0">
                    <span class="grey">机场</span> |
                    <span>{{
                      deviceInfo.dock?.basic_osd?.network_state?.rate > 0
                        ? deviceInfo.dock?.basic_osd?.network_state?.rate +
                          "KB/s"
                        : ""
                    }}</span>
                  </div>
                  <div class="car-flex">
                    <div class="car-flex-item">
                      <div>
                        <img :src="rtkImg" alt="" style="width: 20px" />
                        {{
                          deviceInfo.dock?.basic_osd?.position_state?.rtk_number
                        }}
                      </div>
                      <div class="grey fs12">机场搜星</div>
                    </div>
                    <div class="car-flex-item">
                      <div>
                        <span
                          v-if="
                            deviceInfo.dock?.basic_osd?.position_state
                              ?.is_fixed == 0
                          "
                          >未收敛</span
                        >
                        <span
                          v-if="
                            deviceInfo.dock?.basic_osd?.position_state
                              ?.is_fixed == 1
                          "
                          >收敛中</span
                        >
                        <span
                          v-if="
                            deviceInfo.dock?.basic_osd?.position_state
                              ?.is_fixed == 2
                          "
                          >已收敛</span
                        >
                        <span
                          v-if="
                            deviceInfo.dock?.basic_osd?.position_state
                              ?.is_fixed == 3
                          "
                          class="red"
                          >收敛失败</span
                        >
                      </div>
                      <div class="grey fs12">位置收敛</div>
                    </div>
                  </div>
                </div>
                <div style="margin-top: 12px">
                  部署设置
                  <div class="car-flex" style="margin-top: 4px">
                    <div class="car-flex-item">
                      <div>
                        <span
                          v-if="
                            deviceInfo.dock?.basic_osd?.alternate_land_point
                              ?.is_configured == 0
                          "
                          class="red"
                          >未设置</span
                        >
                        <span
                          v-if="
                            deviceInfo.dock?.basic_osd?.alternate_land_point
                              ?.is_configured == 1
                          "
                          >已设置</span
                        >
                      </div>
                      <div class="grey fs12">相对备降点</div>
                    </div>
                    <div class="car-flex-item">
                      <div>
                        <span
                          v-if="
                            deviceInfo.dock?.basic_osd?.position_state
                              ?.is_calibration == 0
                          "
                          class="red"
                          >未标定</span
                        >
                        <span
                          v-if="
                            deviceInfo.dock?.basic_osd?.position_state
                              ?.is_calibration == 1
                          "
                          >已标定</span
                        >
                      </div>
                      <div class="grey fs12">机场标定</div>
                    </div>
                  </div>
                </div>
              </div>
            </template>
            <span>车载部署</span>
            <a
              style="color: #fff; margin-left: 10px; font-size: 17px"
              @click="onShowCarPopConfirm()"
              ><EditOutlined
            /></a>
          </DeviceSettingPopover>
        </div>
      </div>
    </div>
    <!-- cmd -->
    <div class="control-cmd-wrapper">
      <div class="control-cmd-header">
        <div>
          远程调试
          <a-switch
            class="debug-btn"
            checked-children="开"
            un-checked-children="关"
            v-model:checked="debugStatus"
            @change="onDeviceStatusChange"
          />
        </div>
        <div>
          <a-button
            size="small"
            type="primary"
            @click="dockTryFly"
            :disabled="
              deviceInfo?.dock?.basic_osd?.mode_code == 4 ? true : false
            "
          >
            机场试飞
            <a-tooltip placement="top">
              <template #title>
                <div>
                  快速验证机场状态。点击机场试飞，自动创建计划，本设备将垂直飞至60m高、云台俯仰角向下90度拍照后返航。
                </div>
              </template>
              <InfoCircleOutlined />
            </a-tooltip>
          </a-button>
        </div>
      </div>
      <div class="control-cmd-box">
        <div
          v-for="(cmdItem, index) in cmdList"
          :key="cmdItem.cmdKey"
          class="control-cmd-item"
          v-show="cmdItem.show"
        >
          <div class="control-cmd-item-left">
            <div class="item-label">{{ cmdItem.status }}</div>
            <div class="item-status-cmd">{{ cmdItem.label }}</div>
          </div>
          <div class="control-cmd-item-right">
            <a-button
              :disabled="!debugStatus || cmdItem.disabled"
              :loading="cmdItem.loading"
              size="small"
              type="primary"
              @click="sendControlCmd(cmdItem, index)"
            >
              {{ cmdItem.operateText }}
            </a-button>
            <a-button
              v-if="
                !dock1Show &&
                cmdItem.label == '舱盖' &&
                cmdItem.status == '开'
              "
              :disabled="!debugStatus"
              size="small"
              type="primary"
              style="margin-left: 8px"
              @click="forcedClose()"
              >强制关闭</a-button
            >
          </div>
        </div>
        <!-- 新增 远程调试 功能 -->
        <div
          class="control-cmd-item"
          v-for="(cmdItem, index) in addCmdList"
          :key="index"
          v-show="cmdItem.show"
        >
          <div class="control-cmd-item-left">
            <div class="item-label">{{ cmdItem.status }}</div>
            <div class="item-status-cmd">{{ cmdItem.label }}</div>
          </div>
          <div class="control-cmd-item-right">
            <a-button
              :disabled="!debugStatus"
              :loading="cmdItem.loading"
              size="small"
              type="primary"
              @click="addControlCmd(cmdItem, index)"
            >
              {{ cmdItem.operateText }}
            </a-button>
          </div>
        </div>
        <!-- 机场空调 -->
        <div class="dock-aircondition">
          <div>机场空调：{{ airconditionName }}</div>
          <div>
            <a-radio-group
              v-model:value="aircondition"
              button-style="solid"
              size="small"
              :disabled="!debugStatus"
              @change="sendAirs"
            >
              <a-radio-button :value="0" class="air-btns">空闲</a-radio-button>
              <a-radio-button :value="1" class="air-btns">制冷</a-radio-button>
              <a-radio-button :value="2" class="air-btns">制热</a-radio-button>
              <a-radio-button :value="3" class="air-btns">除湿</a-radio-button>
            </a-radio-group>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
  
  <script setup lang="ts">
import {
  defineProps,
  defineEmits,
  ref,
  watch,
  onMounted,
  reactive,
  onUnmounted,
  computed,
  createVNode,
} from "vue";
import {
  CloseOutlined,
  InfoCircleOutlined,
  EditOutlined,
  ExclamationCircleOutlined,
} from "@ant-design/icons-vue";
// import { useDockControl } from './useDockControl'
import { useDockControl } from "./use-dock-control";
import { DeviceInfoType, EDockModeCode } from "/@/types/device";
import DeviceSettingPopover from "./DeviceSettingPopover.vue";
import rtkImg from "/@/assets/icons/rtks.png";

import {
  cmdList as baseCmdList,
  DeviceCmdItem,
  DeviceCmd,
} from "/@/types/device-cmd";
import { useMyStore } from "/@/store";
import {
  updateDeviceCmdInfoByOsd,
  updateDeviceCmdInfoByExecuteInfo,
} from "/@/utils/device-cmd";
import DeviceSettingBox from "./DeviceSettingBox.vue";
import {
  testFlightApi,
  silentModeApi,
  getDeviceTopo,
  setRtkApi,
  forceCloseApi,
  getAirImgApi,
  setAirImgApi,
} from "/@/api/manage";
import { ELocalStorageKey } from "/@/types";
import { message, Modal } from "ant-design-vue";
const props = defineProps<{
  sn: any;
  deviceInfo: DeviceInfoType;
  dockName: any;
}>();
const workspaceId = localStorage.getItem(ELocalStorageKey.WorkspaceId) || "";
const store = useMyStore();
const initCmdList = baseCmdList.map((cmdItem) => Object.assign({}, cmdItem));
const cmdList = ref(initCmdList);
const silent_mode = ref(0); // 机场禁音 0 未开启 1 开启
const addCmdList = ref([
  {
    label: "静音模式",
    status: "未开启",
    operateText: "开启",
    cmdKey: "silent_mode",
    func: "silentMode",
    silentmode: 0,
    loading: false,
    show: true,
  },
  {
    label: "图片空中回传",
    status: "关",
    operateText: "开启",
    cmdKey: "img_mode",
    func: "imgMode",
    loading: false,
    silentmode: 0, // 0 为关闭false，1为开启true
    show: true, // 只有机场2、3才能显示
  },
]);
// 机场空调
const airconditionName = ref<string>("空闲");
// 机场空调
const aircondition = ref<number>(0);
const times = ref<any>();
const debugStatus = ref(false);
const stopWatchList = ref<any>([]); // 停止 watch
stopWatchList.value.push(
  watch(
    () => store?.state.AirState.data,
    (data) => {
      if (data) {
        // console.log(82222,data, props.sn);
        if (data && data.length > 0) {
          data.map((item: any) => {
            if (item.sn === props.sn) {
              const tims = Date.now();
              if (!times.value) {
                aircondition.value = item.value;
                airconditionName.value = item.name;
              } else {
                if (tims < times.value) {
                  return;
                }
                aircondition.value = item.value;
                airconditionName.value = item.name;
              }
            }
          });
        }
      }
    },
    {
      deep: true,
      immediate: true,
    }
  )
);
// const nums = ref<number>(1);
const snArr = ref<any>([]);
const setcarInfo = reactive({
  visible: false,
  loading: false,
}); // 车载部署参数
const deviceAll = ref<any>([]); // 机场所有的设备
const dock3Show = computed(() => {
  let flag = false;
  const devices = deviceAll.value.filter(
    (item: any) => item.device_sn == props.sn
  );
  if (devices && devices.length > 0) {
    const types = devices[0]?.device_name;
    if (types == "DJI Dock3") {
      flag = true;
    }
  }
  return flag;
}); // 机场3类型
const dock1Show = computed(() => {
  let flag = false;
  const devices = deviceAll.value.filter(
    (item: any) => item.device_sn == props.sn
  );
  if (devices && devices.length > 0) {
    const types = devices[0]?.device_name;
    if (types == "DJI Dock") {
      flag = true;
    }
  }
  return flag;
}); // 机场1类型
// 判断机场类型
function judgeDockType(dockType: any) {
  let flag = false;
  const devices = deviceAll.value.filter(
    (item: any) => item.device_sn == props.sn
  );
  if (devices && devices.length > 0) {
    const types = devices[0]?.device_name;
    if (types == dockType) {
      flag = true;
    }
  }
  return flag;
}
// 获取机场设备
async function getOnlineTopo() {
  getDeviceTopo(workspaceId).then((res) => {
    if (res.code !== 0) {
      return;
    }
    deviceAll.value = res.data;
    getImgMode();
  });
}
onMounted(() => {
  getOnlineTopo();
});
// 根据设备osd信息更新信息
stopWatchList.value.push(
  watch(
    () => props.deviceInfo,
    (value: any) => {
      // console.log(70,value);

      let osdInfos = {
        dock: value.dock,
        device: value.device,
        gateway: value.gateway,
      };
      if (snArr.value.includes(props.sn)) {
        // console.log('数组包含该元素');
      } else {
        snArr.value.push(props.sn);
      }
      // console.log(2022,cmdList.value,props.dockName);
      let flag = false;
      const devices = deviceAll.value.filter(
        (item: any) => item.device_sn == props.sn
      );
      if (devices && devices.length > 0) {
        const types = devices[0]?.device_name;
        if (types == "DJI Dock") {
          flag = true;
        }
      }

      // if (props.dockName && props.dockName.includes('小')) {
      cmdList.value.map((item) => {
        item.show = true;
        // 小机场 隐藏下列配置按钮
        // 推杆
        if (item.cmdKey == DeviceCmd.PutterOpen) {
          item.show = flag;
        }
        return item;
      });
      // }
      updateDeviceCmdInfoByOsd(cmdList.value, osdInfos);
      if (
        props.deviceInfo &&
        props.deviceInfo.dock?.basic_osd?.mode_code == 2
      ) {
        debugStatus.value = true;
      } else {
        debugStatus.value = false;
      }
      // 处理静音 状态
      if (value?.dock?.basic_osd?.silent_mode == 1) {
        addCmdList.value[0] = {
          label: "静音模式",
          status: "已开启",
          operateText: "关闭", //按钮
          cmdKey: "silent_mode",
          silentmode: 0, // {"0":"非静音模式","1":"静音模式"}
          func: "silentMode",
          loading: false,
          show: true,
        };
      } else {
        addCmdList.value[0] = {
          label: "静音模式",
          status: "未开启",
          operateText: "开启",
          silentmode: 1, //{"0":"非静音模式","1":"静音模式"}
          cmdKey: "silent_mode",
          func: "silentMode",
          loading: false,
          show: true,
        };
      }
    },
    {
      immediate: true,
      deep: true,
    }
  )
);
// 根据机场指令执行状态更新信息
stopWatchList.value.push(
  watch(
    () => store?.state.devicesCmdExecuteInfo,
    (devicesCmdExecuteInfo) => {
      if (snArr.value.includes(props.sn)) {
        // console.log('数组包含该元素',devicesCmdExecuteInfo);
        if (props.sn && devicesCmdExecuteInfo?.[props.sn]) {
          // console.log(79999, cmdList.value, devicesCmdExecuteInfo, props.sn);
          updateDeviceCmdInfoByExecuteInfo(
            cmdList.value,
            devicesCmdExecuteInfo[props.sn]
          );
        }
      } else {
        // snArr.value.push(props.sn)
      }
    },
    {
      immediate: true,
      deep: true,
    }
  )
);
const emit = defineEmits(["close-control-panel"]);

function closeControlPanel() {
  // nums.value = 1;
  // emit('close-control-panel', props.sn, false)
  emit("close-control-panel", props.sn);
}

// dock 控制指令
async function onDeviceStatusChange(status: boolean) {
  let result = false;
  if (status) {
    result = await dockDebugOnOff(props.sn, true);
  } else {
    result = await dockDebugOnOff(props.sn, false);
  }
  if (!result) {
    if (status) {
      debugStatus.value = false;
    } else {
      debugStatus.value = true;
    }
  }
}

const { sendDockControlCmd, dockDebugOnOff } = useDockControl();

async function sendControlCmd(cmdItem: DeviceCmdItem, index: number) {
  const success = await sendDockControlCmd(
    {
      sn: props.sn,
      cmd: cmdItem.cmdKey,
      action: cmdItem.action,
    },
    true
  );
  if (success) {
    // updateDeviceSingleCmdInfo(cmdList.value[index])
  }
}
async function sendAirs(e: any) {
  const num = e.target.value;
  const params = {
    sn: props.sn,
    cmd: DeviceCmd.AirConditionerModeSwitch,
    action: num,
  };
  const currentTimestamp = Date.now();
  const nextSecondTimestamp = currentTimestamp + 2000;
  times.value = nextSecondTimestamp;
  await sendDockControlCmd(params, true);
}
// 机场 试飞
async function dockTryFly() {
  if (!props.sn) {
    return;
  }
  let dockMode = props.deviceInfo?.dock?.basic_osd?.mode_code; // 机场状态
  if (dockMode == 2) {
    message.warning("当前处于远程调试状态，请先关闭！");
    return;
  }
  testFlightApi(props.sn).then((res) => {
    // console.log(252,res);
    if (res.code == 0) {
      message.success("机场试飞成功");
    }
  });
}
// 远程调试 新增 功能 发送指令
async function addControlCmd(cmdItem: any, index: number) {
  // 静音
  if (cmdItem.cmdKey == "silent_mode") {
    addCmdList.value[index].loading = true;
    addCmdList.value[index].status = cmdItem.silentmode
      ? "开启中..."
      : "关闭中...";
    const params = {
      dockSn: props.sn,
      mode: cmdItem.silentmode,
    };
    await silentModeApi(params);
  }
  // 图片回传
  if (cmdItem.cmdKey == "img_mode") {
    addCmdList.value[index].loading = true;
    addCmdList.value[index].status = cmdItem.silentmode
      ? "开启中..."
      : "关闭中...";
    const params = {
      dockSn: props.sn,
      b: cmdItem.silentmode ? false : true,
    };
    imgModeClose(params);
  }
}
// 图片回传操作
async function imgModeClose(params: any) {
  const res = await setAirImgApi(params);
  addCmdList.value[1].loading = false;
  if (res.code == 0) {
    getImgMode();
  }
}
// 获取 图片回传操作
async function getImgMode() {
  if (!props.sn) {
    return;
  }
  let params = {
    dockSn: props.sn,
  };
  const res = await getAirImgApi(params);
  if (res.code == 0) {
    if (res.data) {
      const status = res.data.air_transfer_enable;
      // 关闭
      if (status == 0) {
        addCmdList.value[1].status = "未开启";
        addCmdList.value[1].operateText = "开启";
        addCmdList.value[1].silentmode = 0;
      } else {
        addCmdList.value[1].status = "已开启";
        addCmdList.value[1].operateText = "关闭";
        addCmdList.value[1].silentmode = 1;
      }
    }
  }
  const show = judgeDockType("DJI Dock");
  addCmdList.value[1].show = !show;
}
// 强制关闭
const forcedClose = () => {
  Modal.confirm({
    title: "提示",
    icon: createVNode(ExclamationCircleOutlined),
    content: `请确认飞行器不在舱内，否则可能导致桨叶被夹`,
    centered: true,
    class: "modal-class",
    onOk() {
      if (!props.sn) {
        return;
      }
      forceCloseApi(props.sn).then((res) => {
        if (res.code == 0) {
          message.success("关闭成功！");
        }
      });
    },
    onCancel() {},
  });
};
// 打开 车载部署 弹框
const onShowCarPopConfirm = () => {
  setcarInfo.visible = true;
};
// 车载部署 弹框 确定
const onCarConfirm = async () => {
  // const devices = deviceAll.value.filter(
  //   (item: any) => item.device_sn == props.sn
  // );
  // console.log(604, devices);
  // if (devices && devices.length > 0) {
  //   const one = devices[0]
  // }
  let params = {
    sn: props.sn,
    lng: "",
    lat: "",
    height: "",
  };
  setcarInfo.loading = true;
  const res = await setRtkApi(params);
  if (res.code == 0) {
    setcarInfo.loading = false;
    message.success("一键标定成功");
    setcarInfo.visible = false;
  } else {
    setcarInfo.loading = false;
    // message.error('一键标定失败')
  }
};
// 车载部署 弹框 取消
const onCarCancel = () => {
  setcarInfo.visible = false;
};
onUnmounted(() => {
  if (stopWatchList.value) {
    stopWatchList.value.forEach((stopWatch: any) => stopWatch());
    stopWatchList.value = [];
  }
});
</script>
  
  <style lang='scss' scoped>
.dock-control-panel {
  // position: absolute;
  // left: calc(100% + 10px);
  // top: 0px;
  width: 400px;
  // width: 480px;
  padding: 5px !important;
  background: #000;
  color: #fff;
  border-radius: 2px;

  .dock-control-panel-header {
    border-bottom: 1px solid #515151;
    height: 36px;
    line-height: 36px;
  }

  .control-cmd-wrapper {
    margin-top: 10px;
    background: #3d3d3d;
    .control-cmd-header {
      font-size: 14px;
      font-weight: 600;
      padding: 10px 10px 0px;
      display: flex;
      justify-content: space-between;
      align-items: center;
      .debug-btn {
        margin-left: 10px;
        border: 1px solid #585858;
      }
    }

    .control-cmd-box {
      display: flex;
      flex-wrap: wrap;
      justify-content: space-between;
      padding: 4px 10px;
      .control-cmd-item {
        // width: 220px;
        width: 49%;
        height: 50px;
        display: flex;
        align-items: center;
        justify-content: space-between;
        border: 1px solid #666;
        margin: 4px 0;
        padding: 0 8px;

        .control-cmd-item-left {
          display: flex;
          flex-direction: column;
          .item-label {
            font-weight: 700;
          }
          .item-status-cmd {
            color: #ffffff73;
            font-size: 12px;
          }
        }
      }
      // 机场空调
      .dock-aircondition {
        width: 100%;
        height: 65px;
        display: flex;
        align-items: center;
        justify-content: space-around;
        border: 1px solid #666;
        margin: 4px 0;
        padding: 5px 8px;
        flex-direction: column;
        .air-btns {
          padding: 0 20px;
        }
      }
    }
  }
}
.device-set-add {
  background-color: #3d3d3d;
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  padding: 0px 10px 4px 10px;
  .set-add-item {
    width: 47%;
    // width: 220px;
    height: 40px;
    // height: 58px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    border: 1px solid #666;
    margin: 4px 0;
    padding: 0 8px;

    .set-add-item-left {
      display: flex;
      flex-direction: column;

      .item-label {
        font-weight: 700;
        color: #868686;
      }
    }
  }
}
.grey {
  color: #868686;
}
.red {
  color: red;
}
.fs12 {
  font-size: 12px;
}
.car-flex {
  display: flex;
  .car-flex-item {
    width: 150px;
  }
}
</style>